import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from './BufferOverflow.mjs';
import { CoroutineStart_DEFAULT_getInstance3qi77grrvmsn3 as CoroutineStart_DEFAULT_getInstance } from '../CoroutineStart.mjs';
import {
  Channel3r72atmcithql as Channel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import { newCoroutineContext2tdpc8c02iv5t as newCoroutineContext } from '../CoroutineContext.mjs';
import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ChannelCoroutine12l2gxei4u780 as ChannelCoroutine } from './ChannelCoroutine.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from '../CoroutineExceptionHandler.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Key_instancepi2bbb0csu5f as Key_instance } from '../Job.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../CancellableContinuationImpl.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function produce(_this__u8e3s4, context, capacity, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  return produce_0(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
}
function produce_0(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  onCompletion = onCompletion === VOID ? null : onCompletion;
  var channel = Channel(capacity, onBufferOverflow);
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = new (ProducerCoroutine())(newContext, channel);
  if (!(onCompletion == null)) {
    coroutine.invokeOnCompletion_n6cffu_k$(onCompletion);
  }
  coroutine.start_50fwcj_k$(start, coroutine, block);
  return coroutine;
}
var ProducerCoroutineClass;
function ProducerCoroutine() {
  if (ProducerCoroutineClass === VOID) {
    class $ extends ChannelCoroutine() {
      constructor(parentContext, channel) {
        super(parentContext, channel, true, true);
      }
      get_isActive_quafmh_k$() {
        return super.get_isActive_quafmh_k$();
      }
      onCompleted_pl6y9g_k$(value) {
        this._channel_1.close$default_kcbl7u_k$();
      }
      onCompleted_whnx9v_k$(value) {
        return this.onCompleted_pl6y9g_k$(value instanceof Unit() ? value : THROW_CCE());
      }
      onCancelled_gb68wi_k$(cause, handled) {
        var processed = this._channel_1.close_ukldxa_k$(cause);
        if (!processed && !handled) {
          handleCoroutineException(this.context_1, cause);
        }
      }
      cancel$default_880p35_k$(cause, $super) {
        return this.cancel$default_8haxne_k$(cause, ($super == null ? true : $super instanceof ProducerCoroutine()) ? $super : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ProducerCoroutine', VOID, VOID, [SendChannel()], [1, 0]);
    ProducerCoroutineClass = $;
  }
  return ProducerCoroutineClass;
}
function *awaitClose(_this__u8e3s4, block, $completion) {
  var tmp;
  if (block === VOID) {
    tmp = awaitClose$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.js.getCoroutineContext' call
  // Inline function 'kotlin.check' call
  if (!($completion.get_context_h02k06_k$().get_y2st91_k$(Key_instance) === _this__u8e3s4)) {
    var message = 'awaitClose() can only be invoked from the producer context';
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  }
  try {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    (yield () => {
      var uCont = $completion;
      var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
      cancellable.initCancellability_shqc60_k$();
      var cont = cancellable;
      _this__u8e3s4.invokeOnClose_xlde4o_k$((it) => {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = cont;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$8 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.resumeWith_rk9gbt_k$(tmp$ret$8);
        return Unit_instance;
      });
      return cancellable.getResult_fck196_k$();
    });
  }finally {
    block();
  }
  return Unit_instance;
}
function awaitClose$lambda() {
  return Unit_instance;
}
//region block: exports
export {
  awaitClose as awaitClose10k42f6qjplpu,
  produce_0 as produce3s4oh9balbl5b,
  produce as produce1iljho2c8bp6o,
};
//endregion

//# sourceMappingURL=Produce.mjs.map
